export const UNITS = ["g", "kg", "ml", "L", "pcs", "dozen", "pkts", "box"];
const FAMILY = { g: ["m", 1], kg: ["m", 1000], ml: ["v", 1], l: ["v", 1000], pcs: ["c", 1], dozen: ["c", 12] };
const fam = (u) => FAMILY[(u || "").toLowerCase()] || ["x:" + (u || "").toLowerCase(), 1];

export const compatibleUnits = (u) => UNITS.filter((x) => fam(x)[0] === fam(u)[0]);
export const toBase = (qty, from, to) => (Number(qty) || 0) * fam(from)[1] / fam(to)[1];
export const GST_SLABS = [0, 5, 12, 18, 28];
export const fmtD = (iso) => {
  if (!iso) return "";
  const s = String(iso);
  if (s.length > 10 && s[10] === "T") return fmtDT(s).slice(0, 10);
  return s.slice(0, 10).split("-").reverse().join("-");
};
export const today = () => new Date(Date.now() + 5.5 * 3600000).toISOString().slice(0, 10);
export const newRef = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + Math.random());

export function fmtDT(iso) {
  if (!iso) return "";
  const p = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true }).formatToParts(new Date(iso));
  const g = (t) => p.find((x) => x.type === t)?.value;
  return `${g("day")}-${g("month")}-${g("year")} ${g("hour")}:${g("minute")} ${(g("dayPeriod") || "").toUpperCase()}`;
}
export const toDMY = (iso) => (iso && /^\d{4}-\d{2}-\d{2}/.test(iso) ? fmtD(iso) : "");
export function fromDMY(t) {
  const m = String(t || "").trim().match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/) || null;
  const iso = m ? `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}` : /^\d{4}-\d{2}-\d{2}$/.test(String(t).trim()) ? String(t).trim() : "";
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00Z`);
  return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === iso ? iso : "";
}
